import { oneStrategyURL, strategyURL } from "../../services/api";
import api from "../../services/instanceapi";
import { checkErrorMessage } from "../../utils/utils";
import {
  LOADING_STRATEGY,
  FETCH_STRATEGY,
  FETCH_STRATEGY_FAIL,
  PATCH_STRATEGY_FAIL,
  PATCH_STRATEGY,
} from "./actionTypes";

export const loadStrategy = () => async (dispatch) => {
  dispatch({
    type: LOADING_STRATEGY,
  });
  try {
    const strategy = await api.get(strategyURL());
    const data = strategy.data[0];
    dispatch({
      type: FETCH_STRATEGY,
      payload: {
        id: data.id,
        name: data.name,
        activity: data.activity,
        useAssistant: data.useAssistant,
        useLearning: data.useLearning,
        vision: data.vision,
        goal: data.goal,
        success: data.success,
        duty: data.duty,
        image: data.image,
        swot: data.swots,
        nextCodir:data.nextCodir,
        message: "OK",
        status: 0,
      },
    });
    return Promise.resolve();
  } catch (e) {
    const message = checkErrorMessage(e);
    const status = e?.response?.status;
    if (status !== 200) {
      dispatch({
        type: FETCH_STRATEGY_FAIL,
        message: message,
        status: status,
      });
    }
    return Promise.reject(e);
  }
};

export const patchStrategy = (id, data) => async (dispatch) => {
  try {
    const strategy = await api.patch(oneStrategyURL(id), data);
    dispatch({
      type: PATCH_STRATEGY,
      payload: {
        name: data.name,
        nextCodir: data.nextCodir,
        message: "OK",
        status: strategy.status,
      },
    });
    return Promise.resolve();
  } catch (e) {
    const message = checkErrorMessage(e);
    const status = e?.response?.status;
    if (status !== 200) {
      dispatch({
        type: PATCH_STRATEGY_FAIL,
        message: message,
        status: status,
      });
    }
    return Promise.reject(e);
  }
};
